import { FC } from 'react';
import { translate } from 'translations';
import BarChart from '@components/common/barChart/barChart';
import styles from './vulnerabilityBreakDown.module.scss';

const VulnerabilityBreakDown: FC<VulnerabilityBreakDownProps> = ({ vulnerabilities }: VulnerabilityBreakDownProps) => {
    const getKeyByValue = (rating: number) => {
        switch (true) {
            case rating > 70:
                return 'strong';
            case rating > 40:
                return 'fair';
            default:
                return 'poor';
        }
    };

    const getVulnerabilitiesData = () => {
        const VulnerabilityBreakDownData: any = [];
        vulnerabilities.map(vulnerability =>
            VulnerabilityBreakDownData.push({
                id: vulnerability.vulnerabilityName ?? translate('General'),
                [getKeyByValue(vulnerability.rating)]: vulnerability.rating
            })
        );
        return VulnerabilityBreakDownData;
    };
    return (
        <div className={styles['vulnerability-break-down']}>
            <BarChart data={getVulnerabilitiesData()} />
        </div>
    );
};

interface VulnerabilityBreakDownProps {
    vulnerabilities: Vulnerability[];
}

export interface Vulnerability {
    vulnerabilityName: string;
    rating: number;
}

export default VulnerabilityBreakDown;
